import {stage} from '../../../../config/stage';

const paypalConfig = {
    prod: {
        clientId: 'AUyN4S-P3v8XeIC9uxeeT6GtX_wy6F84NmrVtDy8gfuPYSjCrPXuTSKLkvfAv1_KOI7P89CjhUzk9jiW',
        environment: 'production' as const,
    },
    test: {
        clientId: 'AbM938D8aul8HfNZ_rG_fmTp3F8q9NLFJHQoUXv_95HiHtbn4w4C-CqQl5lb48hSGDSfxWeGHebT5jNX',
        environment: 'sandbox' as const,
    },
    dev: {
        clientId: 'AfcDZ1CY_5msbJyJvyPTgUDi6dZrpFPXs8mwETtAoo1t51x0LEUmLyKl3PYInSXvu-7_blejDxZm-6Ro',
        environment: 'sandbox' as const,
    },
    ide: {
        clientId: 'AfcDZ1CY_5msbJyJvyPTgUDi6dZrpFPXs8mwETtAoo1t51x0LEUmLyKl3PYInSXvu-7_blejDxZm-6Ro',
        environment: 'sandbox' as const,
    },
};

export const paypalClientId = paypalConfig[stage].clientId;
export const paypalEnvironment = paypalConfig[stage].environment;

export const paypalOptions = {
    currency: 'USD',
    intent: 'capture' as const,
};
